import { BooleanInput, TextInput } from "react-admin";

import { DataKind } from "../../types";
import { CustomCreate, CustomUtcDateTimeInput } from "../custom";

function OtcMaintenanceWindowCreate() {
  return (
    <CustomCreate checkPermissionFor={DataKind.OtcMaintenanceWindow}>
      <TextInput
        label="Name"
        defaultValue={"OtcMaintenance"}
        source="id"
        required
        InputProps={{ readOnly: true }}
        style={{ display: "none" }}
      />
      <CustomUtcDateTimeInput
        label="Start Time(UTC)"
        source="start_time"
        required
      />
      <BooleanInput label="Completed" source="completed" />
    </CustomCreate>
  );
}

export default OtcMaintenanceWindowCreate;
